import { reducer as formReducer } from "redux-form";
import * as types from "../types/pageTypes";

const userInitialState = {
  values: {}
};

export default formReducer.plugin({
  user: (state = userInitialState, action) => {
    switch (action.type) {
      default:
        return state;
    }
  }
});
